import React, { useState } from 'react';
import PropTypes from 'prop-types';

import NotificationModal from './NotificationModal';

export const ErrorNotification = props => {
  return (
    <NotificationModal
      isOpen={props.state.isOpen}
      close={props.state.close}
      icon="img/icons/error.svg"
      header="An error occured"
      text="Please, try again later."
    />
  );
};

ErrorNotification.propTypes = {
  state: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
  }),
};

export const TrialRequestedNotification = props => {
  return (
    <NotificationModal
      isOpen={props.state.isOpen}
      close={props.state.close}
      icon="img/icons/request-sent.svg"
      header="Request has been sent"
      text="We’ll call you soon to enroll you on a trial lesson."
    />
  );
};

TrialRequestedNotification.propTypes = {
  state: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
  }),
};

export const SubscribedNotification = props => {
  return (
    <NotificationModal
      isOpen={props.state.isOpen}
      close={props.state.close}
      icon="img/icons/success.svg"
      header="Thank you for your subscription!"
      text="We will send you messages about new courses and useful information for your professional development."
    />
  );
};

SubscribedNotification.propTypes = {
  state: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
  }),
};

export const useNotification = () => {
  const [isOpen, setIsOpen] = useState(false);

  return {
    isOpen,
    open: () => {
      setIsOpen(true);
    },
    close: () => {
      setIsOpen(false);
    },
  };
};

export default {
  Error: ErrorNotification,
  TrialRequested: TrialRequestedNotification,
  Subscribed: SubscribedNotification,
};
